<template>
  <Tile
    :data-idea-id="idea.id"
    :name="currentTranslation.name"
    :is-selectable="isSelectable"
    :selected="selected"
    :always-show-checkbox="true"
    :clickable="!state.isProcessing()"
    :class="`${state.class}`"
    @toggle-selection="$emit('toggleSelection')"
    @on-click="!state.isProcessing() && $emit('edit', idea)"
  >
    <template #image>
      <IdeaPreviewImage
        :idea="idea"
        :enable-overlay="false"
        :checked-background="true"
        :width="300"
        :height="300"
      />
    </template>
    <template v-if="stuckInProcessing" #overlay>
      <div class="overlay">
        <IdeaStuckInProcressing :idea="idea" />
      </div>
    </template>
    <template #status>
      <IdeaStatus :idea="idea" />
    </template>
    <template #sideinfo>
      <div class="channels">
        <Icon
          v-if="isPublishedOnMarketplace"
          icon="sprd-heart"
          class="mp-color"
        />
        <Icon v-if="isPublishedOnShop" icon="shop" class="shop-color" /></div
    ></template>
  </Tile>
</template>

<script>
import ideaHelper from 'commons/ideaHelper/ideaHelper';
import IdeaPreviewImage from 'src/app/partnerarea/idea/previewImage/IdeaPreviewImage.vue';
import { mapGetters } from 'vuex';
import IdeaStatus from 'src/app/partnerarea/idea/detail/IdeaStatus.vue';
import IdeaStuckInProcressing from '../IdeaStuckInProcressing.vue';
import Tile from 'commons/tileView/Tile.vue';

export default {
  name: 'IdeaCard',
  components: {
    IdeaPreviewImage,
    IdeaStatus,
    IdeaStuckInProcressing,
    Tile,
  },
  props: ['idea'],
  emits: ['toggleSelection', 'edit'],
  data() {
    return {
      stuckInProcessing: ideaHelper.isStuckInProcessing(this.idea),
    };
  },
  computed: {
    ...mapGetters({
      isSelected: 'ideas/isSelected',
    }),
    selected() {
      return this.isSelected(this.idea);
    },
    currentTranslation() {
      return ideaHelper.getCurrentTranslation(this.idea) || {};
    },
    isPublishedOnMarketplace() {
      return ideaHelper.isPublishedOnMarketplace(this.idea);
    },
    isPublishedOnShop() {
      return ideaHelper.isPublishedOnShop(this.idea);
    },
    isSelectable() {
      return ideaHelper.isSelectable(this.idea);
    },
    state() {
      return ideaHelper.getState(this.idea);
    },
  },
};
</script>

<style lang="scss" scoped>
@use 'sass:math';

@import 'src/scss/styleguide/mixins/media';
@import 'src/scss/styleguide/colors';

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $grey15;
  padding: 16px;
}

.channels {
  .icon {
    margin-left: 4px;
    width: 20px;
    height: 20px;
  }

  .mp-color {
    color: $mermaid;
  }

  .shop-color {
    color: $pa-color-spreadshop;
  }
}
</style>
